import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

const ScrollToggle = () => {
  // パターン1: 自身にクラスをトグル
  const targets = document.querySelectorAll('.js-scroll-toggle');
  targets.forEach((el) => {
    const start = el.dataset.scrollStart || 'top 80%';
    const end = el.dataset.scrollEnd || 'bottom 20%';

    ScrollTrigger.create({
      trigger: el,
      start: start,
      end: end,
      toggleClass: 'is-act',
    });
  });

  // パターン2: 別要素にクラスをトグル
  const remoteTriggers = document.querySelectorAll('.js-scroll-toggle-remote');
  remoteTriggers.forEach((el) => {
    const targetSelector = el.dataset.scrollTarget;
    if (!targetSelector) return;

    const targetEl = document.querySelector(targetSelector);
    if (!targetEl) return;

    const start = el.dataset.scrollStart || 'top 80%';
    const end = el.dataset.scrollEnd || 'bottom 20%';

    ScrollTrigger.create({
      trigger: el,
      start: start,
      end: end,
      onEnter: () => targetEl.classList.add('is-act'),
      onLeave: () => targetEl.classList.remove('is-act'),
      onEnterBack: () => targetEl.classList.add('is-act'),
      onLeaveBack: () => targetEl.classList.remove('is-act'),
    });
  });
};

export default ScrollToggle;
